module.exports = __webpack_public_path__ + "img/camera-plus.543053da.svg";